<template>
  <div class="filters__unner">
    <h2>Выбрать по параметрам</h2>
    <div class="filters__filter-block">
      <form @submit.prevent="fetchProducts">
        <div class="filters__top">
          <div class="filters__filter">
            <vs-select
                v-model="filters.outlet"
                :multiple="false"
                :options="outletOptions"
                :reduce="(option) => option.id"
                placeholder="Вид скидки"
                @update:modelValue="fetchFilters"
            />
          </div>
          <div class="filters__filter">
            <vs-select
                v-model="filters.category"
                :multiple="false"
                :options="category_options"
                placeholder="Выберите категорию товаров"
                @update:modelValue="fetchFilters"
            />
          </div>

          <div class="filters__filter">
            <vs-select
                v-model="filters.brand"
                :multiple="false"
                :options="brand_options"
                placeholder="Выбрать бренд"
                @update:modelValue="fetchFilters"
            />
          </div>

          <button type="submit" class="filters__product-button">Показать товары</button>
        </div>
      </form>
    </div>
  </div>


  <div class="filters__cards-block">
    <div class="filters__cards-buttons">
         </div>
    <div class="filters__cards-content">
      <div class="filters__cards"><!-- Первый блок товаров (до 8) -->
        <ProductItem
            v-for="product in products.slice(0, 8)"
            :key="product.id"
            :product="product"
            :is-auth="isAuth"
            @add-to-cart="addToCart"
            :is-outlet="true"
        />
      </div>

<!--      <ExclusivesDiscountOutlet />-->

      <!-- Второй блок товаров (остальные) -->
      <div class="filters__cards">
        <ProductItem
            v-for="product in products.slice(8)"
            :key="product.id"
            :product="product"
            :is-auth="isAuth"
            @add-to-cart="addToCart"
        />

      </div>
    </div>
  </div>

  <PaginationProducts
      v-model="currentPage"
      :page-count="totalPages"
      @page-changed="handlePageChange"
  />


</template>

<script>

import VsSelect from 'vs-vue3-select';
import cart from '../scripts/shop-cart';
import axios from 'axios';
import ProductItem from '../components/ProductItem.vue';
import Paginate from 'vuejs-paginate-next';
// import ExclusivesDiscountOutlet from "./ExclusivesDiscountOutlet.vue";
import PaginationProducts from "./PaginationProducts.vue";
import Treeselect from '@zanmato/vue3-treeselect';

export default {
  components: {
    // ExclusivesDiscountOutlet,
    Treeselect, VsSelect, ProductItem, PaginationProducts,},
  data() {
    return {
      category_options: [],
      product_collection_options: [],
      brand_options: [],
      manufacturer_options: [],
      isAuth: window.IS_AUTHENTICATED,
      outletOptions: [
        {label: 'Вид скидки', id: 'all'},
        { label: 'Скидки от производителя', id: 'discount' },
        { label: 'Короткий срок годности', id: 'srok' }
      ],
      filters: {
        product_collection: null,
        brand: [],
        category: [],
        // manufacturer: [],
        outlet: 'all'
      },
      availableFilters: {},
      products: [],
      totalPages: 0, // Общее количество страниц
      currentPage: 1, // Текущая страница
      limit: 16,
      isFirstLoad: true,
    };
  },
  methods: {
    async fetchProducts(order_by = 'sortd') {
      console.log('Filters:', this.filters);

      // Собираем все фильтры в один объект для запроса
      let query = {};

      query['outlet'] = true;

      // Добавляем динамические фильтры
      for (const key in this.filters) {
        if (this.filters[key] && this.filters[key].length > 0) {
          query[key] = this.filters[key];
        }
      }

      if (typeof order_by === 'string' || order_by instanceof String) {
        const order_params = ['sortd', 'discount', 'popular', 'cheap'];
        const is_order_by = order_params.includes(order_by);
        if (is_order_by)
          query['order_by'] = order_by;
      }

      query['page'] = this.currentPage;

      // Выполняем запрос к API
      axios.post('/api/products', query)
          .then(response => {
            console.log('Products fetch response:', response.data);
            this.totalPages = response.data.totalPages;
            this.products = response.data.products;

          })
          .catch(error => {
            console.error('Error fetching products:', error);
            alert("Ошибка при загрузке продуктов: " + error.message);
          });
    },
    async fetchFilters() {
      let query;


      query = ``;
console.log(this.filters);
      if (this.filters.outlet) {
        query += `&outlet=${this.filters.outlet}`;
      }else{
        query += `&outlet=0`;
      }
      if (this.filters.category) {
        query += `&category=${this.filters.category}`;
      }

/*      if (this.filters.brand) {
        query += `&brand=${this.filters.brand}`;
      }*/
      if (this.filters.manufacturer) {
        query += `&manufacturer=${this.filters.manufacturer}`;
      }

      const response = await fetch(`/api/filters?${query}`);
      let responsejson = await response.json();
      console.log('json:', responsejson);

      let top_filters = responsejson.top_filters;

      // Преобразуем объекты в массивы
      this.brand_options = top_filters.brands;
      this.manufacturer_options = top_filters.manufacturers;
      this.category_options = top_filters.category;

      this.availableFilters = responsejson.bottom_filters;
      if (this.isFirstLoad) {
        this.isFirstLoad = false; // Сбрасываем флаг после первой загрузки
        this.fetchProducts();
      }
    },
    handlePageChange(pageNumber) {
      this.currentPage = pageNumber;
      this.fetchProducts();
    },
    addToCart(productId) {

      let modalBasketAdd = document.querySelector('.modal-basket');

      cart.addItem(productId, 1).then(function (data) {
        let product_image = modalBasketAdd.querySelector('.product-image img');
        let product_name = modalBasketAdd.querySelector('a.product-name');
        let product_price_one = modalBasketAdd.querySelector('span.product-price');
        let product_desc = modalBasketAdd.querySelector('p.desc-cart-item');
        let item_active = data['cart_item']['item_active'];
        let quantity = item_active['quantity'];
        let price = item_active['price'];

        product_image.src = '/images/products/' + item_active.image;
        product_name.textContent = item_active.name;
        product_price_one.textContent = price + ' р';

        const wordForms = ['товар', 'товара', 'товаров'];
        const lastDigit = quantity % 10;
        const lastTwoDigits = quantity % 100;
        let wordForm
        if (lastTwoDigits >= 11 && lastTwoDigits <= 14) {
          wordForm = wordForms[2]; // "товаров"
        } else {
          if (lastDigit === 1) {
            wordForm = wordForms[0]; // "товар"
          } else if (lastDigit >= 2 && lastDigit <= 4) {
            wordForm = wordForms[1]; // "товара"
          } else {
            wordForm = wordForms[2]; // "товаров"
          }
        }
        // Перемножаем количество и цену и округляем до целого числа
        const totalPrice = Math.round(quantity * price);
        product_desc.textContent = 'В корзине ' + quantity + ' ' + wordForm + ' на сумму ' + totalPrice + ' р';

        modalBasketAdd.classList.add('activeModalBasket');
      }).catch(function (error) {
        console.error('Error adding item to cart:', error);
        this.showError('Ошибка при добавлении товара в корзину.');
      }.bind(this));

    },
  },
  mounted() {
    this.fetchFilters();
    this.fetchProducts();
  },
};

</script>